import * as commonHeader from '@umu/common-header';
import { IUserInfo } from '@umu/umu-types';

export interface ICommonHeaderData {
    userInfo: IUserInfo;
    siteHost: string;
    system: string;
    lang: string;
    hostElId?: string;
    isCAdministrator?: boolean;

    siblingSubHeader?: boolean;
    profileUrl?: string;
    onLogoClick?: () => void;
    isInAITools?: boolean;
    totalPoints?: number;
}

export default commonHeader;

export function initHeader(data: ICommonHeaderData) {
    const {
        userInfo,
        hostElId = 'common-header',
        system = 'CN',
        lang = 'zh-cn',
        siteHost,
        isCAdministrator = false,
        siblingSubHeader = true,
        profileUrl,
        onLogoClick,
        isInAITools = false,
        totalPoints = 0
    } = data;
    const {
        enterprise_info = {
            role_type: '1',
            enterprise_id: '0',
            enterprise_name: '',
            logo_mobile: '',
            logo: '',
            show_name: ''
        }
    } = userInfo;
    const {
        uid,
        umu_id,
        student_id,
        teacher_id,
        user_name,
        avatar,
        person_home_url,
        achievement_url,
        phone,
        email,
        remark,
        phone_number,
        user_level,
        user_growth_points,
        show_user_level
    } = userInfo;

    commonHeader.render({
        hostEl: document.getElementById(hostElId),
        isCAdministrator,
        siteHost,
        system,
        lang,
        siblingSubHeader,
        userInfo: {
            ...userInfo,
            uid: uid || '',
            umu_id,
            student_id,
            teacher_id,
            user_name,
            avatar,
            person_home_url,
            achievement_url,
            phone,
            email,
            remark,
            login_name: userInfo.login_name || userInfo.user_name,
            phone_number,
            user_level,
            user_growth_points,
            show_user_level,
            user_medal: userInfo.user_medal
        },
        enterpriseInfo: {
            role_type: String(enterprise_info.role_type) || '1',
            enterprise_id: enterprise_info.enterprise_id || '0',
            enterprise_name: enterprise_info.enterprise_name || enterprise_info.show_name || '',
            logo_pc: enterprise_info.logo || enterprise_info.logo_mobile || ''
        },
        profileUrl,
        onLogoClick,
        isInAITools,
        totalPoints
    });
}
